import { defaultReportsFilterFields } from '@/features/reports/constants/defaultReportsFilterFields.constant'

export const reportFilters = {
  default: defaultReportsFilterFields.textField,
  created_at_gteq: defaultReportsFilterFields.dateField,
  created_at_lteq: defaultReportsFilterFields.dateField,
  closed_at_gteq: defaultReportsFilterFields.dateField,
  closed_at_lteq: defaultReportsFilterFields.dateField,
  due_at_gteq: defaultReportsFilterFields.dateField,
  due_at_lteq: defaultReportsFilterFields.dateField,
  applicable_start_date_lteq: defaultReportsFilterFields.dateField,
  applicable_end_date_gteq: defaultReportsFilterFields.dateField,
  city_id_eq: defaultReportsFilterFields.citySelectField,
  product_id_eq: defaultReportsFilterFields.productSelectField,
  establishment_company_id_eq: defaultReportsFilterFields.establishmentCompanySelectField,
  client_company_id_eq: defaultReportsFilterFields.clientCompanySelectField,
  client_branch_id_eq: defaultReportsFilterFields.clientCompanyBranchSelectField,
  client_company_branch_id_eq: defaultReportsFilterFields.clientCompanyBranchSelectField,
  company_kind_eq: defaultReportsFilterFields.clientCompanyKindSelectField,
  client_equipment_id_eq: defaultReportsFilterFields.clientEquipmentSelectField,
  in_effect_until_gteq: defaultReportsFilterFields.dateField,
  in_effect_until_lteq: defaultReportsFilterFields.dateField,
  kind_eq: defaultReportsFilterFields.billKindSelectField, 
}